 import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Agent.css";
axios.defaults.withCredentials = true;

const Agent = () => {
  const [employees, setEmployees] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);  
  const [newEmployee, setNewEmployee] = useState({
    name: "", email: "", department: "", phone: "", password: "",
  });
  const [updatedRoles, setUpdatedRoles] = useState({});
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
     axios.get("/auth/me", { withCredentials: true })
      .then(res => setCurrentUser(res.data))
      .catch(() => setCurrentUser(null))
      .finally(() => {
         fetchEmployees();
        fetchDepartments();
      });
  }, []);
        
  const fetchEmployees = async () => {
    try {
      const response = await axios.get("/employees", {
        withCredentials: true,
      });
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.get("/department", {
        withCredentials: true,
      });
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const handleAddEmployee = async () => {
    const { name, email, department, phone, password } = newEmployee;
    if (!name || !email || !department || !phone || !password) {
      alert("Please complete all fields before adding an employee.");
      return;
    }
    try {
      await axios.post("/employees", newEmployee, {
        withCredentials: true,
      });
      setNewEmployee({ name: "", email: "", department: "", phone: "", password: "" });
      fetchEmployees();
    } catch (error) {
      if (error.response?.data?.error) alert(error.response.data.error);
      else {
        console.error("Error adding employee:", error);
        alert("An unexpected error occurred.");
      }
    }
  };

  const handleDeleteEmployee = async (id) => {
    if (currentUser && id === currentUser.id) {
      alert("You cannot delete yourself.");
      return;
    }
    const confirmDelete = window.confirm("Are you sure you want to delete this employee?");
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(`/employees/${id}`, {
        withCredentials: true,
      });
      if (response.status === 200) {
        alert("Employee deleted successfully!");
        fetchEmployees();
      }
    } catch (error) {
      console.error("Error deleting employee:", error);
      alert("Failed to delete employee.");
    }
  };

  const handleChangeRole = (id, newRole) => {
    setUpdatedRoles(prev => ({ ...prev, [id]: newRole }));
  };

  const handleConfirmRoleChange = (id) => {
    if (currentUser && id === currentUser.id) {
      alert("You cannot change your own role.");
      return;
    }
    const newRole = updatedRoles[id];
    if (!newRole) return;

    fetch("/agent", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ employee_id: id, role: newRole }),
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data?.error || "Request failed");
        alert("Role updated successfully.");
        fetchEmployees();
      })
      .catch((err) => {
        console.error("Error updating role", err);
        alert(`Failed to update role: ${err.message}`);
      });
  };


  return (
    <div className="agent-container">
      <div className="employee-form-container">
        <input
          type="text"
          placeholder="Name"
          value={newEmployee.name}
          onChange={(e) =>
            setNewEmployee({ ...newEmployee, name: e.target.value })
          }
          className="employee-input"
        />
        <input
          type="email"
          placeholder="Email"
          value={newEmployee.email}
          onChange={(e) =>
            setNewEmployee({ ...newEmployee, email: e.target.value })
          }
          className="employee-input"
        />
        <select
          value={newEmployee.department}
          onChange={(e) =>
            setNewEmployee({ ...newEmployee, department: e.target.value })
          }
          className="employee-input"
        >
          <option value="">Select Department</option>
          {departments.map((dept) => (
            <option key={dept.id} value={dept.id}>
              {dept.name}
            </option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Phone"
          value={newEmployee.phone}
          maxLength={10}
          onChange={(e) => {
            const value = e.target.value;
            if (/^[0-9]*$/.test(value)) {
              setNewEmployee({ ...newEmployee, phone: value });
            }
          }}
          className="employee-input"
        />
        <input
          type="password"
          placeholder="Password"
          value={newEmployee.password}
          onChange={(e) =>
            setNewEmployee({ ...newEmployee, password: e.target.value })
          }
          className="employee-input"
        />
        <button onClick={handleAddEmployee} className="add-employee-button">
          Add Employee
        </button>
      </div>

      
      <table className="employee-table">
        <thead>
          <tr>
            <th>Employee ID</th><th>Name</th><th>Email</th>
            <th>Department</th><th>Phone</th><th>Actions</th><th>Set Role</th>
          </tr>
        </thead>
        <tbody>
          {employees
            .filter(emp => !currentUser || emp.id !== currentUser.id)
            .map((employee) => (
              <tr key={employee.id}>
                <td>{employee.id}</td>
                <td>{employee.name}</td>
                <td>{employee.email}</td>
                <td>{employee.department_name}</td>
                <td>{employee.phone}</td>
                <td>
                  <button
                    onClick={() => handleDeleteEmployee(employee.id)}
                    className="delete-employee-button"
                  >
                    Delete
                  </button>
                </td>
                <td>
                  <select
                    value={(updatedRoles[employee.id] || employee.role || "user").toLowerCase()}
                    onChange={(e) => handleChangeRole(employee.id, e.target.value)}
                    className="role-select"
                  >
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                  </select>
                  <br />
                  <button
                    onClick={() => handleConfirmRoleChange(employee.id)}
                    className="confirm-role-button"
                  >
                    Confirm
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Agent;
